export const msalConfig = {
  auth: {
    clientId: "eaa76174-4477-46bd-82a4-bfa851d68d8a", // TODO: Replace with your Azure AD app's client ID
    authority: "https://login.microsoftonline.com/77d9c0ac-d469-4e1a-a632-8bee62f081b7", // TODO: Replace with your Azure AD tenant ID
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
}; 